import React from 'react';

import './InputPassword.scss';

type InputAttributes = React.InputHTMLAttributes<HTMLInputElement>;

export interface InputPasswordProps extends InputAttributes {
  autoFocus?: boolean;
}

export interface InputPasswordState {
  visible: boolean;
}

class InputPassword extends React.Component<InputPasswordProps, InputPasswordState> {

  state = {
    visible: false
  }

  render() {
    const { visible } = this.state;
    const { ...attrs } = this.props;
    const eyeClasses = 'fas fa-eye password-eye ' + (visible ? 'text-primary' : '');
    let classnames = 'form-control gray-input-text login-input';
    if (attrs.className) {
      classnames += ' ' + attrs.className;
    }
    return (
      <>
        <div className="form-group password-group">
          <input
            {...attrs}
            type={this.state.visible ? 'text' : 'password'}
            className={classnames}
          />
          <i className={eyeClasses} onClick={this.onEyeClicked}></i>
        </div>
      </>
    );
  }

  onEyeClicked = () => {
    this.setState({ visible: !this.state.visible });
  }

}

export default InputPassword;
